export default [
  {
    name: 'SettingsList',
    path: '/settings',
    component: () => import('src/pages/settings/SettingsList.vue')
  },
  {
    name: 'SettingsGeneralsList',
    path: '/settings/generals',
    component: () => import('src/pages/settings/generals/SettingsGeneralsList.vue')
  },
  {
    name: 'SettingsGeneralsEdit',
    path: '/settings/generals/:id/edit',
    component: () => import('src/pages/settings/generals/SettingsGeneralsEdit.vue')
  }
]
